import React from 'react';
import './VoteBar.css';

function VoteBar({ 
  votes, 
  totalVotes, 
  partyCode, 
  otherVotes, 
  otherPartyCode, 
  showVotes = true,
  partyColor,
  otherPartyColor
}) {
  // Calculate percentages based on total votes from both candidates
  const total = totalVotes || (votes + (otherVotes || 0));
  const percentage = total > 0 ? (votes / total) * 100 : 0;
  const otherPercentage = total > 0 && otherVotes ? (otherVotes / total) * 100 : 0;

  const getPartyColor = (code) => {
    switch (code) {
      case 'ALP':
        return '#E13940'; // Red for ALP
      case 'LP':
      case 'LNP':
      case 'NP':
      case 'CLP':
        return '#1E3D8F'; // Same blue for all coalition parties
      case 'GRN':
      case 'GVIC':
        return '#006400'; // Same green for all Greens
      case 'IND':
        return '#800080'; // Purple for Independents
      case 'KAP':
        return '#FFD700'; // Yellow for Katter's Australian Party
      case 'XEN':
      case 'CA':
        return '#FFA500'; // Orange for Centre Alliance/Xenophon
      default:
        return '#8B4513'; // Brown for others
    }
  };

  // Use passed colors if provided, otherwise use the getPartyColor function
  const primaryColor = partyColor || getPartyColor(partyCode);
  const secondaryColor = otherPartyColor || getPartyColor(otherPartyCode);

  return (
    <div className="vote-bar-container">
      <div className="vote-bar-wrapper">
        <div className="vote-bar">
          <div className="vote-bar-fills">
            <div 
              className="vote-bar-fill"
              style={{ 
                width: `${percentage}%`,
                backgroundColor: primaryColor
              }}
            >
              <span className="vote-percentage">{percentage.toFixed(1)}%</span>
            </div>
            {otherVotes && (
              <div 
                className="vote-bar-fill"
                style={{ 
                  width: `${otherPercentage}%`,
                  backgroundColor: secondaryColor
                }}
              >
                <span className="vote-percentage">{otherPercentage.toFixed(1)}%</span>
              </div>
            )}
          </div>
          <div className="tick-mark"></div>
        </div>
      </div>
      <div className="vote-info">
        <div className="party-info">
          <span className="party-code" style={{ color: primaryColor }}>{partyCode}</span>
          {showVotes && <span className="vote-count">{votes.toLocaleString()} votes</span>}
        </div>
        {otherVotes && (
          <div className="party-info">
            <span className="party-code" style={{ color: secondaryColor }}>{otherPartyCode}</span>
            {showVotes && <span className="vote-count">{otherVotes.toLocaleString()} votes</span>}
          </div>
        )}
      </div>
    </div>
  );
}

export default VoteBar; 